/* import __COLOCATED_TEMPLATE__ from './roadmap-info-alert.hbs'; */
import Component from '@glimmer/component';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    heading: string;
  };
  Blocks: {
    default: [];
  };
}

export default class RoadmapInfoAlert extends Component<Signature> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    RoadmapInfoAlert: typeof RoadmapInfoAlert;
  }
}
